/* Quorix theme scripts */
(function () {
  'use strict';

  var Q = window.QuorixTheme || {};
  var S = Q.strings || {};
  function str(key, fallback) { return S[key] || fallback; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || Q.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2);
      }
    });
  }

  /* Header shadow on scroll */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile drawer */
  var drawer = $('[data-drawer]');
  var drawerOpenBtn = $('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', open);
    if (drawerOpenBtn) drawerOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var first = $('.mobile-nav a', drawer); if (first) first.focus(); }
    else if (drawerOpenBtn) drawerOpenBtn.focus();
  }
  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', function () { setDrawer(true); });
  $$('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* Reveal on scroll */
  var reveals = $$('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* 3D tilt on cards */
  if (finePointer && !reduceMotion) {
    $$('[data-tilt]').forEach(function (el) {
      var raf = 0;
      el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1), box-shadow .5s cubic-bezier(.22,1,.36,1)';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transition = 'transform .12s linear, box-shadow .5s cubic-bezier(.22,1,.36,1)';
          el.style.transform = 'perspective(900px) rotateX(' + (-y * 7).toFixed(2) + 'deg) rotateY(' + (x * 9).toFixed(2) + 'deg) translateZ(0)';
        });
      });
      el.addEventListener('pointerleave', function () {
        cancelAnimationFrame(raf);
        el.style.transition = 'transform .8s cubic-bezier(.22,1,.36,1), box-shadow .5s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
      });
    });
  }

  /* Collection sorting */
  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Quantity inputs */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('[data-qty-input]', wrap);
    if (!input) return;
    function step(d) {
      var min = parseInt(input.min || '0', 10);
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + d);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var minus = $('[data-qty-minus]', wrap), plus = $('[data-qty-plus]', wrap);
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
  });

  /* Product gallery */
  function showMedia(gallery, id) {
    if (!gallery || !id) return;
    var found = false;
    $$('.gallery__item', gallery).forEach(function (item) {
      var on = String(item.getAttribute('data-media-id')) === String(id);
      if (on) found = true;
      item.classList.toggle('is-active', on);
      if (!on) {
        var v = $('video', item); if (v) v.pause();
      }
    });
    if (!found) return;
    $$('[data-thumb]', gallery).forEach(function (t) {
      var on = String(t.getAttribute('data-thumb')) === String(id);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  $$('[data-gallery]').forEach(function (gallery) {
    $$('[data-thumb]', gallery).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(gallery, t.getAttribute('data-thumb')); });
    });
  });

  /* Variant picker */
  $$('[data-product-form]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var format = root.getAttribute('data-money-format') || Q.moneyFormat;
    var section = root.closest('[data-product-root]');
    var gallery = section ? $('[data-gallery]', section) : null;
    var groups = $$('[data-option-group]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var priceWrap = $('[data-price-wrap]', root);
    var stockEl = $('[data-stock]', root);
    var stockText = $('[data-stock-text]', root);
    var lowStock = parseInt(root.getAttribute('data-low-stock') || '10', 10);
    var inventory = {};
    try { inventory = JSON.parse(($('[data-inventory-json]', root) || {}).textContent || '{}'); } catch (e) { inventory = {}; }

    function updateStock(variant) {
      if (!stockEl || !stockText) return;
      var qty = inventory[String(variant.id)];
      stockEl.classList.remove('stock--low', 'stock--out');
      if (!variant.available) {
        stockEl.classList.add('stock--out');
        stockText.textContent = str('soldOut', 'Sold out');
      } else if (typeof qty === 'number' && qty <= lowStock) {
        stockEl.classList.add('stock--low');
        stockText.textContent = str('onlyLeft', 'Only 999999 left in stock').replace('999999', qty);
      } else {
        stockText.textContent = str('inStock', 'In stock, ready to ship');
      }
    }

    function selectedOptions() {
      return groups.map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }
    function update() {
      var opts = selectedOptions();
      groups.forEach(function (g, i) {
        var label = $('[data-option-label]', g);
        if (label && opts[i]) label.textContent = opts[i];
      });
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v.options.every(function (o, idx) { return o === opts[idx]; })) { variant = v; break; }
      }
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = str('unavailable', 'Unavailable');
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? str('addToCart', 'Add to cart') : str('soldOut', 'Sold out');
      updateStock(variant);
      if (priceEl) priceEl.textContent = formatMoney(variant.price, format);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price, format) : '';
      }
      if (priceWrap) priceWrap.classList.toggle('price--sale', !!onSale);
      if (variant.featured_media) showMedia(gallery, variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-option-input]', root).forEach(function (input) { input.addEventListener('change', update); });
  });

  /* Add to cart with toast (falls back to normal form submit) */
  var toast = $('[data-cart-toast]');
  var toastTimer = 0;
  function showToast(item) {
    if (!toast) return;
    var img = $('[data-toast-img]', toast);
    var title = $('[data-toast-title]', toast);
    if (title) title.textContent = item.product_title || item.title || '';
    if (img) {
      img.innerHTML = '';
      if (item.image) {
        var el = document.createElement('img');
        el.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        el.alt = '';
        img.appendChild(el);
      }
    }
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4500);
  }
  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  $$('form[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      var submitter = e.submitter;
      if (submitter && submitter.name !== 'add' && submitter.getAttribute('data-add-button') === null) return;
      e.preventDefault();
      var btn = $('[data-add-button]', form);
      var err = $('[data-form-error]', form);
      if (err) err.hidden = true;
      if (btn) btn.classList.add('is-disabled');
      var body = new FormData(form);
      fetch((Q.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data.description || r.data.message || str('addError', 'Could not add to cart.'));
          showToast(r.data);
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
        })
        .then(function (cart) { if (cart) setCartCount(cart.item_count); })
        .catch(function (error) {
          if (err) { err.textContent = error.message; err.hidden = false; }
        })
        .then(function () { if (btn) btn.classList.remove('is-disabled'); });
    });
  });
  $$('[data-toast-close]').forEach(function (b) { b.addEventListener('click', function () { toast.classList.remove('is-visible'); }); });

  /* Cart page: update quantities on change, require policy agreement before checkout */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    $$('[data-qty-input]', cartForm).forEach(function (input) {
      var t = 0;
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () { cartForm.submit(); }, 500);
      });
    });
    var agree = $('[data-cart-agree]', cartForm);
    var agreeErr = $('[data-cart-agree-error]', cartForm);

    /* "You may also like" popup before checkout: shown once per visit, never again after X */
    var upsell = $('[data-upsell]');
    var UPSELL_OFF = 'quorix_upsell_off';
    var UPSELL_SEEN = 'quorix_upsell_seen';
    function store(kind, key, value) {
      try {
        var s = window[kind];
        if (value === undefined) return s.getItem(key);
        s.setItem(key, value);
      } catch (err) { return null; }
    }
    var upsellReady = upsell && $$('.upsell__item', upsell).length > 0;
    var goingToCheckout = false;
    function goCheckout() {
      goingToCheckout = true;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = '1';
      cartForm.appendChild(hidden);
      cartForm.submit();
    }
    function closeUpsell() {
      upsell.hidden = true;
      document.documentElement.classList.remove('upsell-open');
    }
    if (upsellReady) {
      $$('[data-upsell-close]', upsell).forEach(function (b) {
        b.addEventListener('click', function () {
          store('localStorage', UPSELL_OFF, '1');
          closeUpsell();
          goCheckout();
        });
      });
      var cont = $('[data-upsell-continue]', upsell);
      if (cont) cont.addEventListener('click', function () { closeUpsell(); goCheckout(); });
      $$('[data-upsell-add]', upsell).forEach(function (b) {
        b.addEventListener('click', function () {
          b.classList.add('is-disabled');
          fetch((Q.cartAddUrl || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-upsell-add')), quantity: 1 }] })
          }).then(function () { window.location.reload(); })
            .catch(function () { b.classList.remove('is-disabled'); });
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !upsell.hidden) closeUpsell();
      });
    }

    cartForm.addEventListener('submit', function (e) {
      if (goingToCheckout) return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      if (agree && !agree.checked) {
        e.preventDefault();
        if (agreeErr) agreeErr.hidden = false;
        agree.focus();
        return;
      }
      if (upsellReady && !store('localStorage', UPSELL_OFF) && !store('sessionStorage', UPSELL_SEEN)) {
        e.preventDefault();
        store('sessionStorage', UPSELL_SEEN, '1');
        upsell.hidden = false;
        document.documentElement.classList.add('upsell-open');
        var first = $('[data-upsell-continue]', upsell);
        if (first) first.focus();
      }
    });
    if (agree) agree.addEventListener('change', function () { if (agreeErr && agree.checked) agreeErr.hidden = true; });
  }

  /* Delivery dates: today + business days (Mon-Fri), shown in the visitor's language */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  /* "IL:7-15\nUS:8-15" -> { IL: [7, 15], US: [8, 15] } */
  function parseCountryDays(text) {
    var map = {};
    (text || '').split(/[\n,;]+/).forEach(function (line) {
      var m = line.trim().match(/^([A-Za-z]{2})\s*:\s*(\d+)\s*-\s*(\d+)$/);
      if (m) map[m[1].toUpperCase()] = [parseInt(m[2], 10), parseInt(m[3], 10)];
    });
    return map;
  }
  function countryName(code) {
    try { return new Intl.DisplayNames([Q.locale || 'en'], { type: 'region' }).of(code); }
    catch (e) { return code; }
  }
  function renderDelivery(country) {
    var fmt;
    try { fmt = new Intl.DateTimeFormat(Q.locale || undefined, { day: 'numeric', month: 'long' }); }
    catch (e) { fmt = { format: function (d) { return d.toDateString(); } }; }
    var now = new Date();
    $$('[data-delivery]').forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min'), 10);
      var max = parseInt(box.getAttribute('data-max'), 10);
      var code = (country || box.getAttribute('data-country') || '').toUpperCase();
      var days = parseCountryDays(box.getAttribute('data-by-country'))[code];
      var label = $('[data-delivery-label]', box);
      if (days) {
        min = days[0];
        max = days[1];
        if (label && label.getAttribute('data-template')) {
          label.textContent = label.getAttribute('data-template')
            .replace('[country]', countryName(code))
            .replace('[min]', min)
            .replace('[max]', max);
        }
      }
      var out = $('[data-delivery-dates]', box);
      if (!out || isNaN(min) || isNaN(max)) return;
      out.textContent = (out.getAttribute('data-template') || '[start] - [end]')
        .replace('[start]', fmt.format(addBusinessDays(now, min)))
        .replace('[end]', fmt.format(addBusinessDays(now, max)));
    });
  }
  /* Cart shipping table: mark the visitor's own country */
  function highlightShipRow(code) {
    $$('[data-ship-country]').forEach(function (row) {
      row.classList.toggle('is-current', row.getAttribute('data-ship-country') === String(code).toUpperCase());
    });
  }
  if ($('[data-delivery]') || $('[data-ship-table]')) {
    renderDelivery();
    /* Shopify's visitor-country lookup (based on the visitor's IP) */
    if (window.fetch) {
      fetch('/browsing_context_suggestions.json', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var c = data && data.detected_values && data.detected_values.country;
          if (c && c.handle) {
            renderDelivery(c.handle);
            highlightShipRow(c.handle);
          }
        })
        .catch(function () {});
    }
  }

  /* Language switcher submits right away */
  $$('[data-lang-switch]').forEach(function (select) {
    select.addEventListener('change', function () { if (select.form) select.form.submit(); });
  });

  /* Shopify 3D models (model-viewer UI + AR) */
  function setupModels() {
    var modelsJson = $('[data-product-models]');
    if (!modelsJson || !window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function (error) {
          if (error) return;
          $$('model-viewer').forEach(function (mv) {
            try { new window.Shopify.ModelViewerUI(mv); } catch (e) { /* noop */ }
          });
        }
      },
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: function (error) {
          if (error || !window.ShopifyXR) return;
          try {
            window.ShopifyXR.addModels(JSON.parse(modelsJson.textContent));
            window.ShopifyXR.setupXRElements();
          } catch (e) { /* noop */ }
        }
      }
    ]);
  }
  setupModels();
})();
